import { Attrs, Node } from 'hubspot-prosemirror/pm/model';
import { EditorState, Transaction } from 'hubspot-prosemirror/pm/state';
import { NodePos } from '../../types';

export function findNode(
  nodeToSearch: Node,
  predicate: (n: Node, parent: Node) => boolean
) {
  let found: NodePos | undefined;
  nodeToSearch.descendants((node, pos, parent) => {
    if (parent && predicate(node, parent)) found = { node, pos };
    if (found) return false;
    return true;
  });
  return found;
}

export function findAllNodes(
  nodeToSearch: Node,
  predicate: (n: Node, parent: Node) => boolean
) {
  const nodesFound: NodePos[] = [];
  nodeToSearch.descendants((node, pos, parent) => {
    if (parent && predicate(node, parent)) nodesFound.push({ node, pos });
    return true;
  });
  return nodesFound;
}

export function replaceAllNodes(
  editorState: EditorState,
  predicate: (n: Node, parent: Node) => boolean,
  transform: (np: NodePos, tr: Transaction) => Transaction
) {
  let transaction = editorState.tr.setMeta('addToHistory', false);
  const nodesFound = findAllNodes(editorState.doc, predicate);
  nodesFound.forEach((nodepos) => {
    transaction = transform(nodepos, transaction);
  });
  return editorState.apply(transaction);
}

// Starting with the node, Check each node to see if it in the Parent tag and
// if so add the StyleString to each of its matching Child Tags styles.
// If it is not, then run this function on each of its children.
export function assignStyleToChildTagInParentTag(
  node: ChildNode,
  StyleString: string,
  nameOfChildTag: string,
  nameOfParentTag: string
) {
  if (node.nodeName === nameOfParentTag) {
    node.childNodes.forEach((child) => {
      const childElement = child as Element;
      if (childElement.nodeName === nameOfChildTag) {
        childElement.setAttribute(
          'style',
          `${childElement.getAttribute('style')} ${StyleString}`
        );
      }
    });
  }
  if (node.childNodes) {
    node.childNodes.forEach((child) => {
      assignStyleToChildTagInParentTag(
        child,
        StyleString,
        nameOfChildTag,
        nameOfParentTag
      );
    });
  }
}

export function areAttrsEqual(attrs1: Attrs, attrs2: Attrs) {
  return (
    attrs1 &&
    attrs2 &&
    Object.entries(attrs1).sort().toString() ===
      Object.entries(attrs2).sort().toString()
  );
}
